export default {
    brandingFeatures: {
        logo_url: "vendor_groundtrack-logo",
        app_name_prefix: 'GroundTrack',
        splash_asset: "vendor-splash-asset_raven-cdn-groundtrack_optimized.png"
    },
    globals: {
        supportUrl: null, // Setting null to hide till provided by GW, as requested in https://klashwerks.atlassian.net/browse/RAV-8517?focusedCommentId=62396
        supportPhoneNumber: null,
        supportEmail: 'support@groundwidgets.com',
        salesEmail: 'sales.info@groundwidgets.com',        
        fleetManagersGuideUrl: null,
        installingRavenGuideUrl: null,
        buyRavenUrl: 'mailto:sales.info@groundwidgets.com',
        whatsNewUrl: null
    }
}